<div fxLayout="column" fxFlex fxLayoutGap="24px">
  <!-- Header -->
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2>Edit Issuance Configuration</h2>
    <div fxLayout="row" fxLayoutAlign="end center">
      <!-- JSON View Button -->
      <button mat-stroked-button (click)="viewAsJson()" matTooltip="View/Edit as JSON">
        <mat-icon>code</mat-icon>
        JSON View
      </button>
      <button mat-icon-button [routerLink]="['../']" matTooltip="Back to list">
        <mat-icon>arrow_back</mat-icon>
      </button>
    </div>
  </div>

  <!-- Main Form -->
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <!-- Basic Information Card -->
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          <mat-icon>settings</mat-icon>
          Basic Information
        </mat-card-title>
      </mat-card-header>
      <mat-card-content fxLayout="column" fxLayoutGap="16px">
        <!-- Batch Size -->
        <mat-form-field>
          <mat-label>Batch Size</mat-label>
          <input matInput type="number" formControlName="batchSize" placeholder="1" min="1" />
          <mat-icon matSuffix>batch_prediction</mat-icon>
          <mat-hint>Number of credentials issued in a single batch (default: 1)</mat-hint>
          @if (form.get('batchSize')?.invalid && form.get('batchSize')?.touched) {
            <mat-error>Batch size must be at least 1</mat-error>
          }
        </mat-form-field>
        <mat-slide-toggle formControlName="dPopRequired">
          <div fxLayout="column">
            <span><strong>DPop Required</strong></span>
            <span class="toggle-description"
              >Enable DPop (Demonstrated Proof of Possession) for this configuration</span
            >
          </div>
        </mat-slide-toggle>
      </mat-card-content>
    </mat-card>

    <!-- Display Configurations Card -->
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          <mat-icon>view_carousel</mat-icon>
          Display Configurations
        </mat-card-title>
        <mat-card-subtitle>Configure how credentials are displayed to users</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content fxLayout="column" fxLayoutGap="16px">
        <div formArrayName="display">
          @for (display of displays.controls; track $index; let i = $index) {
            <div [formGroupName]="i" class="mat-elevation-z2 display-entry">
              <div fxLayout="row" fxLayoutAlign="space-between center" class="display-entry-header">
                <h3>Display Entry {{ i + 1 }}</h3>
                @if (displays.length > 1) {
                  <button
                    mat-icon-button
                    type="button"
                    color="warn"
                    (click)="removeDisplay(i)"
                    matTooltip="Remove this display configuration"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                }
              </div>
              <div fxLayout="column" fxLayoutGap="16px">
                <div fxLayout="row" fxLayoutGap="16px">
                  <mat-form-field fxFlex>
                    <mat-label>Name</mat-label>
                    <input
                      matInput
                      formControlName="name"
                      placeholder="Enter display name"
                      required
                    />
                    <mat-icon matSuffix>badge</mat-icon>
                  </mat-form-field>
                  <mat-form-field fxFlex>
                    <mat-label>Locale</mat-label>
                    <mat-select formControlName="locale" required>
                      <mat-option value="en-US">English (US)</mat-option>
                      <mat-option value="en-GB">English (UK)</mat-option>
                      <mat-option value="de-DE">German</mat-option>
                      <mat-option value="fr-FR">French</mat-option>
                      <mat-option value="es-ES">Spanish</mat-option>
                      <mat-option value="it-IT">Italian</mat-option>
                    </mat-select>
                    <mat-icon matSuffix>language</mat-icon>
                  </mat-form-field>
                </div>
                <app-image-field
                  [field]="getControl(display.get('logo.uri'))"
                  label="Logo URL"
                ></app-image-field>
              </div>
            </div>
          }
        </div>
        <div fxLayout="row" fxLayoutAlign="center center">
          <button mat-raised-button type="button" (click)="addDisplay()">
            <mat-icon>add</mat-icon> Add Display
          </button>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Webhook Configuration Card -->
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          <mat-icon>webhook</mat-icon>
          Notification Webhook (Optional)
        </mat-card-title>
        <mat-card-subtitle>URL to receive notification data</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <app-webhook-config-edit [group]="getFormGroup('notifyWebhook')"></app-webhook-config-edit>
      </mat-card-content>
    </mat-card>

    <!-- Action Buttons -->
    <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="end center">
      <button mat-button type="button" [routerLink]="['../']">Cancel</button>
      <button mat-flat-button type="submit" [disabled]="form.invalid || loading">
        @if (loading) {
          <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
        }
        @if (!loading) {
          <mat-icon>save</mat-icon>
        }
        Save Configuration
      </button>
    </div>
  </form>
</div>
